import { useTranslate } from '@tolgee/react';
import { COMMUNICATION_SUPPORTED_PLATFORMS } from '../../../config/communication';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import {

  getConversationsList,
  getLabelsList,
  resetAllFilter,
  setActiveConversation,
  setConversationFilterValues,
  setConversationsFilters,
  setLocationUsers
} from '../../../redux/slices/communication';
import { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import IsLoadingIndicator from '../../isLoadingIndicator';
import { useClickAway } from 'react-use';
import FeaturesToolTip from '../../featuresToolTip';
import {
  COMMUNICATION_ENABLE_ASSIGNMENTS,
  COMMUNICATION_ENABLE_LABELS
} from '../constants';

export const ConversationsFiltersCard = () => {
  const {
    data: { locationsUsers, activeConversation }
  } = useSelector((state) => state.communication);
  const {
    data: { filters }
  } = useSelector((state) => state.communication);
  const types = [
    {
      title: 'all',
      value: null
    },
    {
      title: 'direct_message',
      value: 'direct_message',
      icon: 'fa-duotone fa-envelope'
    },
    {
      title: 'review',
      value: 'review',
      icon: 'fa-duotone fa-star'
    },
    {
      title: 'comment',
      value: 'comment',
      icon: 'fa-duotone fa-comment'
    }
  ];
  const [status, setStatus] = useState(filters.status || []);
  const [priority, setPriority] = useState(filters.priority || []);
  const [platforms, setPlatforms] = useState(filters.platforms || []);
  const [type, setType] = useState(
    types.find((item) => item.value === filters.type) || null
  );
  //    TYPE_DIRECT_MESSAGE = "direct_message"
  // TYPE_REVIEW = "review"
  // TYPE_COMMENT = "comment"

  const [typeDropDown, setTypeDropDown] = useState(false);
  const filtersList = [
    {
      title: 'status',
      list: [
        { title: 'open', value: 0 },
        { title: 'closed', value: 1 }
      ],
      values: status,
      setValues: setStatus
    },
    {
      title: 'priority',
      list: [
        { title: 'low', value: 0, color: '#17a2b8' },
        { title: 'medium', value: 1, color: '#ffc107' },
        { title: 'high', value: 2, color: '#dc3545' }
      ],
      values: priority,
      setValues: setPriority
    }
  ];

  const [showDropdown, setShowDropdown] = useState(false);
  const getCurrentUser = () => {
    const user = locationsUsers?.[activeConversation?.location_uuid]?.find(
      (item) => item.uuid === filters?.assigned_user_uuid
    );
    if (!user) return null;
    return {
      uuid: user.uuid,
      name: user.first_name + ' ' + user.last_name
    };
  };
  const [assignedUser, setAssignedUser] = useState(getCurrentUser() || null);
  const setAssignedUserDetails = (user) => {
    setAssignedUser({
      uuid: user?.uuid,
      name: user?.first_name + ' ' + user?.last_name
    });
  };
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const getUsersForLocation = (locationUuid) => {
    if (!locationsUsers?.[locationUuid])
      dispatch(setLocationUsers(locationUuid));
  };
  const [GenralFiltersDropdown, setGenralFiltersDropdown] = useState(false);

  const GeneralFilters = [
    {
      title: 'all_messages',
      key: 'read',
      value: true,
      rest: true,
      icon: 'fa-duotone fa-envelope'
    },
    {
      title: 'read',
      key: 'read',
      value: true,
      rest: false,
      icon: 'fa-duotone fa-eye text-primary'
    },
    {
      title: 'unread',
      key: 'read',
      value: false,
      rest: false,
      icon: 'fa-duotone fa-eye-slash text-dark'
    },
    {
      title: 'marked',
      key: 'is_marked',
      value: true,
      rest: false,
      icon: 'fa-solid fa-star text-warning'
    },
    {
      title: 'spam',
      key: 'is_spam',
      value: true,
      rest: false,
      icon: 'fa-solid fa-octagon-exclamation text-danger'
    }
  ];

  const getCurrentGeneralFilter = () => {
    if (filters?.read === false) return GeneralFilters[2];
    if (filters?.read === true) return GeneralFilters[1];
    if (filters?.is_spam) return GeneralFilters[4];
    if (filters?.is_marked) return GeneralFilters[3];
    return GeneralFilters[0];
  };
  const [activeGeneralFilter, setactiveGeneralFilter] = useState(
    getCurrentGeneralFilter()
  );

  const onFilterActivate = (item) => {
    if (item.rest) {
      setactiveGeneralFilter(item);
      setGenralFiltersDropdown(false);
      return;
    }
    // dispatch(resetAllFilter());
    setactiveGeneralFilter(item);

    setGenralFiltersDropdown(false);
  };
  const filterIsDisabled = () => {
    const tagsUUID = tags.map((item) => item.uuid);
    const initialObject = {
      labels: [],
      assigned_user_uuid: null,
      read: null,
      is_spam: null,
      is_marked: null,
      platforms: [],
      priority: [],
      status: [],
      type: null,
      unassigned: null
    };
    const obj = {
      labels: tagsUUID,
      assigned_user_uuid: assignedUser?.uuid || null,
      read:
        activeGeneralFilter.title === 'read'
          ? true
          : activeGeneralFilter.title === 'unread'
          ? false
          : null,
      is_spam: activeGeneralFilter.title === 'spam' ? true : null,
      is_marked: activeGeneralFilter.title === 'marked' ? true : null,
      platforms,
      priority,
      status,
      type: type?.value || null,
      unassigned: unassignedUser
    };
    // return true if obj and filters are equal
    const res = isEqual(initialObject, filters) && isEqual(obj, initialObject);
    return res;
  };

  const clearFilterIsDisabled = () => {
    const tagsUUID = tags.map((item) => item.uuid);

    const obj = {
      labels: tagsUUID,
      assigned_user_uuid: assignedUser?.uuid || null,
      read:
        activeGeneralFilter.title === 'read'
          ? true
          : activeGeneralFilter.title === 'unread'
          ? false
          : null,
      is_spam: activeGeneralFilter.title === 'spam' ? true : null,
      is_marked: activeGeneralFilter.title === 'marked' ? true : null,
      platforms,
      priority,
      status,
      type: type?.value || null,
      unassigned: unassignedUser
    };
    const initialObject = {
      labels: [],
      assigned_user_uuid: null,
      read: null,
      is_spam: null,
      is_marked: null,
      platforms: [],
      priority: [],
      status: [],
      type: null,
      unassigned: null
    };

    return isEqual(obj, initialObject);
  };
  const [unassignedUser, setUnassignedUser] = useState(
    filters.unassigned || null
  );
  const {
    data: { labelsList }
  } = useSelector((state) => state.communication);
  const getCurrentLabels = () => {
    const labels = filters?.labels?.map((uuid) => {
      return labelsList?.find((item) => item.uuid === uuid);
    });
    return labels;
  };
  const [tags, setTags] = useState(getCurrentLabels() || []);
  // ---------------------------------

  const applyFilters = () => {
    const tagsUUID = tags.map((item) => item.uuid);

    const obj = {
      labels: tagsUUID,
      assigned_user_uuid: assignedUser?.uuid || null,
      read:
        activeGeneralFilter.title === 'read'
          ? true
          : activeGeneralFilter.title === 'unread'
          ? false
          : null,
      is_spam: activeGeneralFilter.title === 'spam' ? true : null,
      is_marked: activeGeneralFilter.title === 'marked' ? true : null,
      platforms,
      priority,
      status,
      type: type?.value || null,
      unassigned: unassignedUser
    };
    console.log('obj', obj);
    // genreral filters:

    dispatch(setConversationFilterValues(obj));
    dispatch(getConversationsList());

    dispatch(setConversationsFilters(false));
    dispatch(setActiveConversation(null));
  };

  const filtersRef = useRef(null);
  const generalFilterRef = useRef(null);
  const typesRef = useRef(null);
  const assignedToRef = useRef(null);

  useClickAway(filtersRef, () => {
    dispatch(setConversationsFilters(false));
  });

  useClickAway(generalFilterRef, () => {
    setGenralFiltersDropdown(false);
  });

  useClickAway(typesRef, () => {
    setTypeDropDown(false);
  });

  useClickAway(assignedToRef, () => {
    setShowDropdown(false);
  });
  const { userData } = useSelector((state) => state.userDetails);
  return (
    <div
      className="position-absolute"
      style={{
        top: 0,
        right: -260,
        width: 250,

        zIndex: 3
      }}
      ref={filtersRef}
    >
      <div className="card position-relative shadow h-100 w-100 d-flex p-4">
        <i
          className="fa-solid fa-xmark position-absolute cursor-pointer end-0 top-0 m-3"
          onClick={() => dispatch(setConversationsFilters(false))}
        ></i>
        <div className="d-flex align-items-center  justify-content-center w-100">
          <p className="fw-bold text-muted text-align-center mb-2 user-select-none">
            {t('communication.conversationsList.filtersTitle')}
          </p>
        </div>
        <div className="d-flex align-items-center">
          <p className="fw-bold text-dark text-align-center mb-1 user-select-none">
            {t('communication.conversationsList.platforms')}
          </p>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {t(
                    'communication.conversationsList.platforms_selected_Tooltip'
                  )}
                </span>
              </Tooltip>
            }
          >
            <i className="fa-duotone fa-circle-info m-1 cursor-pointer"></i>
          </OverlayTrigger>
        </div>

        <div className="d-flex justify-content-start full-width">
          {COMMUNICATION_SUPPORTED_PLATFORMS.map((platform) => {
            return (
              <div
                key={platform.platform}
                className="d-flex align-items-center flex-column justify-content-center"
              >
                <i
                  key={platform.platform}
                  className={`${platform.icon} m-2 cursor-pointer`}
                  onClick={() => {
                    if (platforms.includes(platform.platform)) {
                      setPlatforms(
                        platforms.filter((value) => value !== platform.platform)
                      );
                    } else {
                      setPlatforms([...platforms, platform.platform]);
                    }
                  }}
                  style={{
                    color:
                      platforms?.includes(platform.platform) ||
                      platforms?.length === 0
                        ? platform.color
                        : 'grey',
                    fontSize: '20px'
                  }}
                />
              </div>
            );
          })}
        </div>
        <div className="d-flex flex-end w-100">
          <div className="d-flex w-30 text-start">
            <span className="text-muted fw-bold">
              {t('communication.conversationsList.selected')}:&nbsp;
            </span>
            <span className="fw-bold text-muted">
              {platforms.length === COMMUNICATION_SUPPORTED_PLATFORMS.length ||
              platforms.length === 0
                ? t('all')
                : `${platforms.length}`}
            </span>
          </div>
        </div>
        <div>
          <p className="fw-bold text-dark text-align-center mb-1 user-select-none">
            {t(`communication.conversationsList.general_filters`)}
          </p>
          <Dropdown
            className="w-100 d-flex"
            show={GenralFiltersDropdown}
            onClick={() => {
              setGenralFiltersDropdown(!GenralFiltersDropdown);
            }}
            ref={generalFilterRef}
          >
            <Dropdown.Toggle
              size="sm"
              variant="none"
              id="dropdown-basic"
              className="w-100 p-1 text-muted d-flex align-items-center flex-start w-100"
            >
              <div className="w-25px text-center">
                <i className={activeGeneralFilter.icon} />
              </div>
              <span className="px-1 fw-bold">
                {t(
                  `communication.conversationsList.${activeGeneralFilter.title}`
                )}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              {GeneralFilters.map((item) => (
                <Dropdown.Item
                  key={item.title}
                  onClick={() => onFilterActivate(item)}
                  active={activeGeneralFilter.title === item.title}
                  className="d-flex align-items-center flex-start  w-100"
                >
                  <div className="w-25px text-center">
                    <i className={item.icon} />
                  </div>
                  <span className="px-1 fw-bold">
                    {t(`communication.conversationsList.${item.title}`)}
                  </span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="mt-3">
          <p className="fw-bold text-dark text-align-center mb-1 user-select-none">
            {t(`communication.conversationsList.type`)}
          </p>
          <div className="justify-content-start full-width">
            <Dropdown
              show={typeDropDown}
              className="w-100 d-flex"
              onClick={() => {
                setTypeDropDown(!typeDropDown);
              }}
              ref={typesRef}
            >
              <Dropdown.Toggle
                size="sm"
                variant="none"
                className="w-100 p-1 text-muted d-flex align-items-center flex-start w-100"
              >
                <div className="w-25px text-center">
                  <i className={type?.icon || 'fa-duotone fa-earth-americas'} />
                </div>
                <span className="px-1 fw-bold">
                  {t(`communication.conversationsList.${type?.title || 'all'}`)}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100">
                {types.map((item) => (
                  <Dropdown.Item
                    key={item.title}
                    onClick={() => {
                      setType(item);
                      setTypeDropDown(false);
                    }}
                    active={type === item.value}
                    className="d-flex align-items-center flex-start  w-100"
                  >
                    <div className="w-25px text-center">
                      <i className={item.icon} />
                    </div>
                    <span className="px-1 fw-bold">
                      {t(`communication.conversationsList.${item.title}`)}
                    </span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div>
          {filtersList.map((filter) => {
            return (
              <div key={filter.title} className="mt-3">
                <p className="fw-bold text-dark text-align-center mb-1 user-select-none">
                  {t(`communication.conversationsList.${filter.title}`)}
                </p>
                <div className="justify-content-start full-width">
                  {filter.list.map((item) => {
                    return (
                      <div
                        key={item.value}
                        className="d-flex align-items-center"
                      >
                        <input
                          onChange={() => {
                            if (filter.values.includes(item.value)) {
                              filter.setValues(
                                filter.values.filter(
                                  (value) => value !== item.value
                                )
                              );
                            } else {
                              filter.setValues([...filter.values, item.value]);
                            }
                          }}
                          type="checkbox"
                          checked={filter.values.includes(item.value)}
                          className="form-check-input h-15px w-15px m-1"
                        />
                        {filter.title === 'priority' && (
                          <i
                            className="fa-solid fa-circle"
                            style={{
                              color: item.color
                            }}
                          ></i>
                        )}
                        <p
                          className="fw-bold text-muted text-align-center m-1 user-select-none cursor-pointer"
                          onClick={() => {
                            if (filter.values.includes(item.value)) {
                              filter.setValues(
                                filter.values.filter(
                                  (value) => value !== item.value
                                )
                              );
                            } else {
                              filter.setValues([...filter.values, item.value]);
                            }
                          }}
                        >
                          {t(`communication.conversationsList.${item.title}`)}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <p className="fw-bold text-dark text-align-center mb-1 mt-1 user-select-none mt-3">
          {t(`communication.conversationsList.assigned_to`)}
        </p>
        <FeaturesToolTip
          featureIsActive={
            userData?.feature_list_for_user[COMMUNICATION_ENABLE_ASSIGNMENTS]
          }
          feature={COMMUNICATION_ENABLE_ASSIGNMENTS}
          InnerComponent={() => (
            <div className="w-100 d-flex flex-start align-items-center">
              <Dropdown
                show={showDropdown}
                className={'w-100'}
                onClick={() => {
                  if (
                    userData?.feature_list_for_user[
                      COMMUNICATION_ENABLE_ASSIGNMENTS
                    ]
                  ) {
                    setShowDropdown(!showDropdown);
                    getUsersForLocation(activeConversation?.location_uuid);
                  }
                }}
                ref={assignedToRef}
              >
                <Dropdown.Toggle
                  size="sm"
                  variant="none"
                  className="w-100 p-1 text-muted text-start"
                >
                  <>
                    {assignedUser && (
                      <>
                        <i className="fa-duotone fa-user mx-1"></i>
                        <span className="px-1">{assignedUser?.name}</span>
                      </>
                    )}
                  </>
                  <>
                    {unassignedUser && (
                      <>
                        <i className="fa-duotone fa-user mx-1"></i>
                        <span className="px-1">
                          {t('communication.general_info.no_user_assigned')}
                        </span>
                      </>
                    )}
                  </>
                  <>
                    {!unassignedUser && !assignedUser && (
                      <>
                        <span className="px-2">
                          {t('communication.general_info.no_assigned_user')}
                        </span>
                      </>
                    )}
                  </>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  <Dropdown.Item
                    value={-1}
                    onClick={() => {
                      setUnassignedUser(true);
                      setShowDropdown(false);
                      setAssignedUser(null);
                    }}
                    className={'mb-1'}
                  >
                    <i className="fa-duotone fa-user-large-slash mx-1"></i>
                    <span className="px-1">
                      {t('communication.general_info.no_user_assigned')}
                    </span>
                  </Dropdown.Item>

                  {!locationsUsers?.[activeConversation?.location_uuid] && (
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <IsLoadingIndicator />
                    </div>
                  )}

                  {locationsUsers?.[activeConversation?.location_uuid]?.map(
                    (item, index) => (
                      <Dropdown.Item
                        onClick={() => {
                          setAssignedUserDetails(item);
                          setUnassignedUser(null);
                        }}
                        key={index}
                        value={Number(index)}
                        active={item.uuid == assignedUser?.uuid}
                      >
                        <i className="fa-duotone fa-user mx-1"></i>
                        <span className="px-1">
                          {item?.first_name + ' ' + item?.last_name}
                        </span>
                      </Dropdown.Item>
                    )
                  )}
                </Dropdown.Menu>
              </Dropdown>
              {(assignedUser || unassignedUser) && (
                <div
                  onClick={() => {
                    setAssignedUser(null);
                    setUnassignedUser(null);
                  }}
                  className="cursor-pointer"
                >
                  <i className="fa-duotone fa-times mx-1"></i>
                </div>
              )}
            </div>
          )}
        />

        <div className="mt-3">
          <p className="fw-bold text-dark text-align-center mb-1 mt-1 user-select-none">
            {t(`communication.conversationsList.labels`)}
          </p>
          <InputsTagsFilter tags={tags} setTags={setTags} />
        </div>

        <div className="d-flex flex-end justify-content-end m-1">
          <Button
            // disabled={clearFilterIsDisabled()}
            size="sm"
            variant="secondary"
            onClick={() => {
              dispatch(resetAllFilter());
              setAssignedUser(null);
              setactiveGeneralFilter(GeneralFilters[0]);
              dispatch(getConversationsList());
              setTags([]);
              setPlatforms([]);
              setPriority([]);
              setStatus([]);
              setUnassignedUser(null);
              dispatch(setConversationsFilters(false));
              dispatch(setActiveConversation(null));
            }}
          >
            {t('communication.conversationsList.clear_filters')}
          </Button>
          <Button
            // disabled={filterIsDisabled()}
            className="btn btn-primary btn-sm cursor-pointer mx-2"
            onClick={applyFilters}
          >
            {t('communication.conversationsList.apply_filters')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const InputsTagsFilter = ({ tags, setTags }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  useEffect(() => {
    dispatch(getLabelsList());
  }, []);
  const {
    data: {
      labelsList,
      filters: { labels }
    }
  } = useSelector((state) => state.communication);
  const [allTags, setAllTags] = useState([]);
  useEffect(() => {
    setAllTags(labelsList);
  }, [labelsList]);
  const [filtredTags, setFiltredTags] = useState(allTags);
  useEffect(() => {
    const _filtredTags = allTags.filter(
      (item) =>
        !tags.find((tag) => tag.text.toLowerCase() === item.text.toLowerCase())
    );
    setFiltredTags(_filtredTags);
  }, [tags, allTags]);
  const { userData } = useSelector((state) => state.userDetails);
  const onSearchChange = (e) => {
    if (!userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]) return;
    // search in all labels state
    const __filtredTags = allTags.filter(
      (item) =>
        !tags.find((tag) => tag.text.toLowerCase() === item.text.toLowerCase())
    );
    const _filtredtags = __filtredTags.filter((item) =>
      item.text.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFiltredTags(_filtredtags);
    // setAllTags(filtredtags);
  };
  const onDeleteLabel = (deletedLabel) => {
    const tgs = tags?.filter(
      (item) => item.text.toLowerCase() !== deletedLabel.text.toLowerCase()
    );
    // remove duplicates by uuid and keep entries with null uuid
    setTags(
      tgs.slice()?.sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      })
    );
  };
  const [searchState, setSearchState] = useState(false);
  const dropdownRef = useRef(null);
  useClickAway(dropdownRef, () => {
    setSearchState(false);
  });
  const onAddLabel = (label) => {
    const tgs = [...tags, label];
    // remove duplicates by uuid and keep entries with null uuid
    const uniqueTags = tgs.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.text.toLowerCase() === item.text.toLowerCase())
    );

    setTags(
      uniqueTags.slice()?.sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      })
    );
    setSearchState(false);
    setFiltredTags(
      allTags.filter(
        (item) =>
          !uniqueTags.find(
            (tag) => tag.text.toLowerCase() === item.text.toLowerCase()
          )
      )
    );
    if (inputRef?.current) inputRef.current.value = '';
  };
  const { t } = useTranslate();
  return (
    <div className="w-100 p-relative">
      {tags && tags?.length > 0 && (
        <div className="d-flex flex-wrap overflow-none p-3">
          {tags
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((item, i) => {
              return (
                <div
                  className={`d-flex fw-bold align-items-center mx-1 my-1 fs-7  badge badge-sm cursor-pointer text-break opacity-75`}
                  style={{
                    backgroundColor: `${item.color.replace('opacity', '0.125')}`
                  }}
                  key={i}
                >
                  <span
                    style={{ color: item.color.replace('opacity', '1') }}
                    className="text-truncate"
                  >
                    {item.text}
                  </span>

                  <i
                    className="fa-duotone fa-times mx-1"
                    style={{ color: item.color.replace('opacity', '1') }}
                    onClick={() => onDeleteLabel(item)}
                  ></i>
                </div>
              );
            })}
        </div>
      )}
      {userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS] ? (
        <input
          ref={inputRef}
          placeholder={t('communication.general_info.filter_by_tag')}
          className="form-control form-control-sm w-75 border-0"
          onFocus={() => {
            if (userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS])
              setSearchState(true);
          }}
          // onBlur={() => setSearchState(false)}
          onChange={onSearchChange}
        />
      ) : (
        <FeaturesToolTip
          featureIsActive={
            userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]
          }
          feature={COMMUNICATION_ENABLE_LABELS}
          InnerComponent={() => (
            <p className="fw-bold text-muted fs-7 mx-2">
              {t('communication.general_info.filter_by_tag')}
            </p>
          )}
        />
      )}
      {searchState && filtredTags.length > 0 && (
        // here add condition onClick away
        <div
          className="card p-3 m-1 shadow position-absolute w-100"
          style={{
            zIndex: 4,
            maxHeight: 200,
            overflowY: 'auto',
            maxWidth: '100%'
          }}
          ref={dropdownRef}
        >
          {filtredTags
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((item) => {
              return (
                <div
                  className="w-100 d-flex align-items-center bg-hover-secondary rounded"
                  key={item.uuid}
                  onClick={() => onAddLabel(item)}
                >
                  <div
                    className={`d-flex fw-bold align-items-center mx-1 my-1 px-2 rounded py-1 cursor-pointer`}
                  >
                    <i
                      className="fa-solid fa-circle mx-1"
                      style={{
                        color: item.color.replace('opacity', '1')
                      }}
                    ></i>
                    <span>{item.text}</span>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};
